"use client";

import { getReferralCookie, setReferralCookie } from "@/lib/referral-cookie";
import { useEffect } from "react";

export function ReferralCookieSetter() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const referral = params.get("referral");
    if (!referral) return;
    const existing = getReferralCookie();
    if (existing !== referral) {
      setReferralCookie(referral);
    }
  }, []);
  return null;
}
